import React from 'react';
import { Modal, Button } from 'react-bootstrap';

interface ModalConfirmProps {
    show: boolean;
    size?: 'sm' | 'lg' | 'xl' | undefined;
    onClose: () => void;
    onSave: () => void;
    disableSave?: boolean;
    title: string;
    contentBody?: React.ReactNode;
    contentFooter?: React.ReactNode;
}

const ModalForm: React.FC<ModalConfirmProps> = ({
    show,
    size = 'lg',
    onClose,
    onSave,
    disableSave,
    title,
    contentBody,
    contentFooter,
}) => {
    return (
        <Modal
            animation={false}
            show={show}
            onHide={onClose}
            className="confirm-modal-add"
            size={size}
            aria-labelledby="contained-modal-title-vcenter"
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">{title}</Modal.Title>
            </Modal.Header>

            <Modal.Body>{contentBody}</Modal.Body>

            <Modal.Footer>
                {!contentFooter ? (
                    <>
                        <Button variant="outline-primary" onClick={onClose}>
                            Close
                        </Button>
                        <Button disabled={disableSave} onClick={onSave}>
                            Save
                        </Button>
                    </>
                ) : (
                    contentFooter
                )}
            </Modal.Footer>
        </Modal>
    );
};

export default ModalForm;
